import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import { EventUpgradeIds } from "../config/upgrades";
import EventTileEntity from "../EventTileEntity";

class HuntingCampBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.HUNTING;

	public static readonly frameName = FrameName.HUNTING_CAMP;

	public get range(): number | null {
		if (!super.range) return null;

		let range = super.range;

		// Apply upgrades
		range += getUpgradeCurrentReplaceValueById(EventUpgradeIds.hu_tracking);

		return range;
	}
}

export default HuntingCampBuildingTileEntity;
